import { FormattedMessage } from 'react-intl';

import { Link } from 'react-router-dom';

import {
  domain,
  version,
  source_url,
  statusPageUrl,
  profile_directory as canProfileDirectory,
  termsOfServiceEnabled,
} from 'mastodon/initial_state';

const DividingCircle: React.FC = () => <span aria-hidden>{' · '}</span>;

export const LinkFooter: React.FC<{
  multiColumn: boolean;
}> = ({ multiColumn }) => {
  return (
      <>
        <div className='link-footer'>
          <p>
            <a href='https://using.rcsocial.net' target='_blank' rel='noopener'><FormattedMessage id='footer.userguide' defaultMessage='User Guide' /></a>
            {canProfileDirectory && (
              <>
                <DividingCircle />
                <Link to='/directory'><FormattedMessage id='footer.directory' defaultMessage='Directory' /></Link>
              </>
            )}
            <DividingCircle />
            <Link to='/keyboard-shortcuts'><FormattedMessage id='footer.keyboard_shortcuts' defaultMessage='Keyboard Shortcuts' /></Link>

          <br />

            <Link to='/about' target={multiColumn ? '_blank' : undefined}><FormattedMessage id='footer.about' defaultMessage='About' /></Link>
            {statusPageUrl && (
              <>
                <DividingCircle />
                <a href={statusPageUrl} target='_blank' rel='noopener'><FormattedMessage id='footer.status' defaultMessage='Status' /></a>
              </>
            )}
            <DividingCircle />
            <Link to='/privacy-policy' target={multiColumn ? '_blank' : undefined} rel='privacy-policy'><FormattedMessage id='footer.privacy_policy' defaultMessage='Privacy policy' /></Link>
            {termsOfServiceEnabled && (
              <>
                <DividingCircle />
                <Link to='/terms-of-service' target={multiColumn ? '_blank' : undefined} rel='terms-of-service' ><FormattedMessage id='footer.terms_of_service' defaultMessage='Terms of Service' /></Link>
              </>
            )}
          </p>
        </div>

        <div className='link-footer-rcs'>
          <p>
            <a href='https://using.rcsocial.net' target='_blank' rel='noopener'>
            <img className='logo rcs-logo' title='Click to view our User Guide!' alt='RCsocial.net' src='/rcs/rcsocial_logo.png' />
  	    <img className='rcs-scene' loading='lazy' title='' alt='Catholicism' src={'/rcs/catholicism_scene.jpg?t=' + Date.now()} />
            {/* <script type="text/javascript">add_nonce('scene');</script> */}
            </a>
          </p>
        </div>

        <div className='link-footer'>
          <p>
            <span className='rcs-inspiration' title='2 Corinthians 4:13'>I believed, therefore I spoke.</span><br />
            <span className='rcs-version'>Version {version}</span>
          </p>
        </div>
      </>
  );
};
